/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export class CollectionFilterType {
    public static readonly ALL = 'all';

    public static readonly AVAILABLE = 'available';

    public static readonly RECORDINGS = 'recordings';

    public static readonly WATCHLIST = 'watchlist';

    public static readonly ON_DEMAND = 'vodOnDemand';
}
